import { Grid, styled } from '@mui/material';

export default styled(Grid)(({ theme }) => theme.unstable_sx({
  maxWidth: 780,
  minWidth: 320,
}));
